// extracted by mini-css-extract-plugin
module.exports = {"total":"_3u1Xgx","shine-lines":"_21L4Dz"};